const serverUrl = 'https://api.test.specietor.csw.cl';
const webUrl = 'https://test.specietor.csw.cl';

export default {
  webUrl,
  serverUrl,
};
